import React, {Component} from "react";
import TopLine from "../Main/TopLine/TopLine";
import Events from "./modules/Events";
import Sport from "./modules/Sport";
import Loading from "../../components/Loading";
import Event from "./modules/Event";
import {getLiveSoon} from "../../redux/actions/live";
import {connect} from "react-redux";
import _ from "lodash";

class LiveSoonContainer extends Component {
	componentWillMount() {
		if ( this.props.liveSoon.sports.length === 0 ) {
			this.props.onGetLiveSoon();
		}
	}

	render() {
		const {events, sports, collation, fetching} = this.props.liveSoon;

		const sortedSports = _.sortBy(sports, s => s.name);
		const sortedEvents = _.sortBy(events, e => e.time);

		return (
			<div className="body__container__side-right">
				<TopLine/>

				{fetching && <Loading/>}

				<Events>
					{sortedSports.map((sport) =>
						<Sport key={`live-soon-sport-${sport.id}`} sport={sport}>
							{sortedEvents.filter((event) => event.sport_id === sport.id).map((event) => {
								const collations = collation.filter((item) => {return item.live === event.id});

								return <Event key={`live-soon-event-${event.id}`} event={event} collations={collations}/>;
							})}
						</Sport>
					)}
				</Events>

			</div>
		);
	}
}

export default connect(
	state => ({
		liveSoon : state.liveSoon
	}),
	dispatch => ({
		onGetLiveSoon : () => {
			dispatch(getLiveSoon());
		}
	})
)(LiveSoonContainer);


// WEBPACK FOOTER //
// ./src/app/pages/LiveSoon/LiveSoonContainer.js